(function () {
  function initDynamicSelect(root) {
    const header = root.querySelector('.dynamic-select-header');
    const headerTextEl = header ? header.querySelector('.dynamic-select-option-text') : null;
    const optionsEl = root.querySelector('.dynamic-select-options');
    const hiddenInput = root.querySelector('input[type="hidden"]');

    if (!header || !headerTextEl || !optionsEl || !hiddenInput) return;

    const isColor = root.classList.contains('dynamic-select-color');

    function applyFromOption(opt) {
      if (!opt) return;

      const value = opt.dataset.value || '';          // bei Color: HEX
      const label = opt.dataset.label || value || ''; // bei Color: Label

      // 🔧 Farbauswahl
      if (isColor) {
        // Im Warenkorb steht Label
        hiddenInput.value = label;

        // HEX als Zusatz-Attribut
        hiddenInput.setAttribute('color-value', value);
      } else {
        // Standardverhalten
        hiddenInput.value = value;
        hiddenInput.removeAttribute('color-value');
      }

      // Header-Text
      headerTextEl.textContent = label;

      // Header-Farben (nur Color-Select)
      if (isColor && opt.dataset.value && opt.dataset.textColor) {
        headerTextEl.style.backgroundColor = opt.dataset.value;
        headerTextEl.style.color = opt.dataset.textColor;
      } else if (!isColor) {
        headerTextEl.style.backgroundColor = '';
        headerTextEl.style.color = '';
      }

      // Selected-Klasse setzen
      optionsEl.querySelectorAll('.dynamic-select-option').forEach(function (o) {
        o.classList.remove('dynamic-select-selected');
      });
      opt.classList.add('dynamic-select-selected');

      // Change event triggern
      const ev = new Event('change', { bubbles: true });
      hiddenInput.dispatchEvent(ev);
    }

    // ✅ 1) Respektiert was im HTML scho gsetzt isch
    let activeOpt = optionsEl.querySelector('.dynamic-select-option.dynamic-select-selected');

    // ✅ 2) Falls nüt markiert isch: anhand Input-Wert matchen
    if (!activeOpt) {
      const currentVal = (hiddenInput.value || '').toString().trim();
      const currentColorVal = (hiddenInput.getAttribute('color-value') || '').toString().trim();

      optionsEl.querySelectorAll('.dynamic-select-option').forEach(function (opt) {
        if (activeOpt) return;

        if (isColor) {
          const optLabel = (opt.dataset.label || '').trim();
          const optHex = (opt.dataset.value || '').trim();

          // Match entweder Label (value) oder HEX (color-value)
          if ((currentVal && optLabel === currentVal) || (currentColorVal && optHex === currentColorVal)) {
            activeOpt = opt;
          }
        } else {
          const optVal = (opt.dataset.value || '').trim();
          if (currentVal && optVal === currentVal) {
            activeOpt = opt;
          }
        }
      });
    }

    // ✅ 3) Fallback: erscht Option
    if (!activeOpt) {
      activeOpt = optionsEl.querySelector('.dynamic-select-option');
    }

    if (activeOpt) {
      applyFromOption(activeOpt);
    }

    // Toggle öffnen/schliessen
    header.addEventListener('click', function (e) {
      e.stopPropagation();

      document.querySelectorAll('.dynamic-select.is-open').forEach(function (other) {
        if (other !== root) {
          other.classList.remove('is-open');
        }
      });

      root.classList.toggle('is-open');
    });

    optionsEl.querySelectorAll('.dynamic-select-option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        applyFromOption(opt);
        root.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        root.classList.remove('is-open');
      }
    });
  }

  function initAllDynamicSelects(scope) {
    (scope || document).querySelectorAll('.dynamic-select').forEach(function (root) {
      if (root.dataset.dsInitialized === '1') return;
      root.dataset.dsInitialized = '1';
      initDynamicSelect(root);
    });
  }

  window.initAllDynamicSelects = initAllDynamicSelects;

  document.addEventListener('DOMContentLoaded', function () {
    initAllDynamicSelects(document);
  });
})();
